/** User-supplied SC-CAP-UX05 reading content. Never a formal capability mapping. */
export const editorialSources = [
  {
    id: 'CN-FOREST-2026',
    name: '森林草原防灭火条例',
    publisher: '国务院令第822号／国家林草局',
    url: 'https://www.forestry.gov.cn/c/www/gkxzfg/659970.jhtml',
    kind: '法规',
    whatSupports: '林区火源管理、巡护、防火检查、森林火灾总体工作边界',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-MON-2024',
    name: '关于加强森林草原火灾预警监测体系建设的实施意见',
    publisher: '国家森林草原防灭火指挥部／应急管理部',
    url: 'https://www.mem.gov.cn/gk/zfxxgkpt/fdzdgknr/202409/t20240930_502744.shtml',
    kind: '官方意见',
    whatSupports: '卫星、航空、视频、塔台与地面巡查多源监测，数据汇聚和核查',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-UAV-2026',
    name: '森林草原防火 无人机巡查技术规范 GB/T 47054—2026 解读',
    publisher: '国家市场监督管理总局',
    url: 'https://www.samr.gov.cn/bzjss/bzjd/art/2026/art_c60e23ad7ab846ba8909bc9962133bb0.html',
    kind: '国家标准解读',
    whatSupports: '无人机作业人员、装备与作业流程要求；解读非标准全文',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-VIDEO-2026',
    name: '森林草原防火视频监控系统技术规范 GB/T 47058—2026',
    publisher: '国家标准信息公共服务平台',
    url: 'https://std.samr.gov.cn/gb/search/gbDetailed?id=49FD1852CB7AC31FE06397BE0A0A1304',
    kind: '国家标准目录',
    whatSupports: '视频监控前端、传输、后端的结构；目录非标准全文',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-SYSTEM-2025',
    name: '森林草原防火信息系统技术要求 LY/T 3437—2025',
    publisher: '全国标准信息公共服务平台',
    url: 'https://hbba.sacinfo.org.cn/stdDetail/3f1fe2172df9130f6163608a7aa27272fdb7ea3ff3b8ce180e307480ba8815ed',
    kind: '行业标准目录',
    whatSupports: '火情、热点、队伍、道路、资源等信息系统数据结构',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'NASA-FIRMS',
    name: 'FIRMS Active Fire / Thermal Anomalies & API',
    publisher: 'NASA LANCE/FIRMS',
    url: 'https://firms.modaps.eosdis.nasa.gov/api/area/',
    kind: '技术数据说明',
    whatSupports: '卫星热点位置与时间和分辨率、误判/遮挡限制；不证明已发生火灾',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-ANHUI-CASES',
    name: '安徽五起森林火灾（火情）典型案例',
    publisher: '国家森林草原防灭火指挥部宣传教育',
    url: 'https://slcyfh.mem.gov.cn/kpxc/kpxczlm/202504/t20250429_533290.html',
    kind: '官方案例',
    whatSupports: '火源风险、巡护与防火教育；站点可能返回412防爬',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-HIGHRISE-2021',
    name: '高层民用建筑消防安全管理规定',
    publisher: '应急管理部',
    url: 'https://www.mem.gov.cn/gk/zfxxgkpt/fdzdgknr/gz11/202106/t20210621_405573.shtml',
    kind: '部门规章',
    whatSupports: '建筑图纸、消防设施、疏散通道、管理责任的资料要求',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-HIGHRISE-PDF',
    name: '高层民用建筑消防安全管理规定 原始PDF',
    publisher: '应急管理部',
    url: 'https://www.mem.gov.cn/gk/zfxxgkpt/fdzdgknr/gz11/202106/P020211228721655794602.pdf',
    kind: '官方PDF',
    whatSupports: '法规正式电子文档，需用浏览器在官方站点下载',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-AUDIOVIDEO',
    name: '灾害事故现场音视频采集和传输通用技术要求 解读',
    publisher: '应急管理部',
    url: 'https://www.mem.gov.cn/gk/zcjd/202404/t20240417_485193.shtml',
    kind: '技术标准解读',
    whatSupports: '音视频采集、传输与联网断点、音频优先的限制',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'CN-DRILL-2026',
    name: '保山市高层建筑灭火救援实战综合演练',
    publisher: '应急管理部',
    url: 'https://www.mem.gov.cn/xw/jyll/202601/t20260121_592560.shtml',
    kind: '官方演练实践',
    whatSupports: '热成像、无人机、通风设备和多支力量协作，属于演练不是事故报告',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'DJI-M30T',
    name: 'DJI Matrice 30系列官方技术规格',
    publisher: 'DJI Enterprise',
    url: 'https://enterprise.dji.com/matrice-30/specs',
    kind: '厂商技术说明',
    whatSupports: 'M30T的热成像规格与可见光载荷条件，型号须区分',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'FLY-ELIOS',
    name: 'Elios 3 室内检查与建图',
    publisher: 'Flyability',
    url: 'https://www.flyability.com/elios-3',
    kind: '厂商技术说明',
    whatSupports: '工业室内检查、LiDAR与SLAM；非热火场认证',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'HYTERA',
    name: '应急自组网解决方案（含演示视频）',
    publisher: '海能达',
    url: 'https://www.hytera.com/Global_Sites_zh_CN/product-new/emergency-response/fast-deployment-products-solutions.page',
    kind: '厂商方案视频页',
    whatSupports: '应急组网、临时通信回传；含3分26秒的视频，不保证目标网络可播放',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'LEADER-FAN',
    name: 'BATFAN 3 Li+ 便携式消防通风机',
    publisher: 'LEADER',
    url: 'https://www.leader-group.company/en/firefighting-equipment/fire-ventilators/battery-fans/firefighting-battery-fan-swappable-lithium-battery-batfan-3-li',
    kind: '厂商技术说明及下载入口',
    whatSupports: '便携通风机使用方式和条件，不是每个场景均可启用',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'DRAEGER-XAM',
    name: 'Dräger X-am 8000 多气体检测仪',
    publisher: 'Dräger德尔格',
    url: 'https://www.draeger.com/zh_cn/Products/x-am-8000',
    kind: '厂商中文技术说明',
    whatSupports: '所检测气体取决于传感器配置；浓度读数与样本条件',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'SHARK-COLOSSUS',
    name: 'Colossus 重型消防机器人及模块',
    publisher: 'Shark Robotics',
    url: 'https://www.shark-robotics.com/colossus-firefighting-robot/',
    kind: '厂商模块说明',
    whatSupports: '模块化水炮、通风模块、担架与传感器模块，不等于单机全能力',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'LEADER-SENTRY',
    name: 'LEADER SENTRY B2 建筑结构位移监测',
    publisher: 'LEADER',
    url: 'https://www.leader-group.company/en/safety-and-monitoring-equipment/structural-movement-monitor-telemeter-stability-controller/structural-movement-telemeter-leader-sentry-b2',
    kind: '厂商技术说明',
    whatSupports: '测点位移与报警，不能代替整体结构安全鉴定',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'NIST-ROBOTS',
    name: 'Ground Robot Tests 响应机器人测试方法',
    publisher: 'NIST',
    url: 'https://www.nist.gov/el/intelligent-systems-division-73500/standard-test-methods-response-robots/ground-robot-tests',
    kind: '技术验证方法',
    whatSupports: '测试程序与可复现指标，不能据此认为某型号已认证',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
  {
    id: 'FLIR-LIMIT',
    name: 'Can Thermal Imaging See Through Walls?',
    publisher: 'FLIR',
    url: 'https://www.flir.com/en-gb/discover/home-outdoor/can-thermal-imaging-see-through-walls/',
    kind: '技术限制说明',
    whatSupports: '热像仪不穿墙，主要感知可见表面热信号',
    rights: '仅链接官方网页；不批量镜像，使用前核查版权与可访问性',
    verification: '官方页面来源已在线核对，目标网络/视频播放未测试',
  },
] as const;
